import { DateTimeFormatTypes } from '@/models/common/date-time-format-types.model';
import { DateTimeRangeTypes } from '@/models/common/date-time-range-types.model';
import { TopListRequestDateParameters } from '@/models/top-list/top-list-request-date-parameters.model';
import { getDateTimeRangeFormatted } from '@/utils/get-date-time-range.util';
import { formatDatesInPayload } from '@marfa/bo-utils';
import { defineStore } from 'pinia';

interface TopListFilterState {
  requestDateTimeRange: string[];
}

export const useTopListFilterStore = defineStore('TopListFilterStore', {
  state: (): TopListFilterState => ({
    requestDateTimeRange: getDateTimeRangeFormatted(DateTimeRangeTypes.THIS_MONTH, DateTimeFormatTypes.DATE_TIME_FULL),
  }),
  getters: {
    getTopListRequestDateTimeParameter(state: TopListFilterState): TopListRequestDateParameters {
      const [fromStartActionTime, toStartActionTime] = state.requestDateTimeRange;

      const preparedResult = formatDatesInPayload({
        payload: { fromStartActionTime, toStartActionTime },
        isIncludeTime: true,
        isUnixToString: false,
      }, ['fromStartActionTime', 'toStartActionTime']);

      return {
        fromStartActionTime: Number(preparedResult.fromStartActionTime),
        toStartActionTime: Number(preparedResult.toStartActionTime),
      };
    },
  },
  actions: {
    setTopListRequestDateTimeParameter(dateTimeRange: string[]): void {
      this.requestDateTimeRange = [...dateTimeRange];
    },
  },
});
